import React, { useState } from 'react';

// Dummy data for courses and videos
const coursesData = [
  { id: 1, title: 'Course 1' },
  { id: 2, title: 'Course 2' },
  // Add more courses as needed
];

const videosData = [
  { id: 1, title: 'Video 1', videoUrl: '/pic/video1.mp4' },
  { id: 2, title: 'Video 2', videoUrl: '/pic/video2.mp4' },
  // Add more videos as needed
];

const Sidebar = ({ setSelectedTab }) => {
  return (
    <div className="w-64 bg-blue-500 h-screen p-4 text-white">
      <div className="text-xl font-bold">Dashboard</div>
      <button
        className="text-lg p-2 my-2 w-full text-left"
        onClick={() => setSelectedTab('profile')}
      >
        Profile
      </button>
      <button
        className="text-lg p-2 my-2 w-full text-left"
        onClick={() => setSelectedTab('courses')}
      >
        Courses
      </button>
      <button
        className="text-lg p-2 my-2 w-full text-left"
        onClick={() => setSelectedTab('videos')}
      >
        Videos
      </button>
    </div>
  );
};

const Profile = ({ userProfile }) => {
  return (
    <div className="flex-1 p-4">
      {/* Profile content goes here */}
      <div className="text-xl">Profile</div>
      
      {/* Display user profile information */}
      <div>
        <li>
          <a
            href="./profile" // Updated href to "./profile"
            className={`px-3 py-2 lg:px-3`}
          >
            See Your Profile
          </a>
        </li>
      </div>
    </div>
  );
};

const Courses = () => {
  const courseImageStyle = {
    width: '6cm',
    height: '4cm',
  };

  const enrollButtonStyle = {
    width: '6cm', // Set the button width to 100% to make it responsive
    padding: '8px 0', // Add padding for spacing
  };

  return (
    <div className="flex-1 p-4">
      {/* Courses content goes here */}
      <div className="text-xl">Courses</div>
      <ul>
        {coursesData.map((course) => (
          <li key={course.id} className="my-4">
            {/* Image container */}
            <div className="relative">
              <img
                src="https://tse4.mm.bing.net/th?id=OIP.Iscw4Ys2yXZ23J5OLlPEFAHaEK&pid=Api&P=0&h=220" // Replace with your image path
                alt={course.title}
                style={courseImageStyle}
              />
              {/* Course title */}
              <span className="mx-16 mr-6 text-lg">{course.title}</span>
              {/* Enroll button */}
              <br/>
              <button
                className="px-2 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-full mt-2"
                onClick={() => window.location.href = 'https://buy.stripe.com/14k17AgEUeeh0NOaEE'}
                style={enrollButtonStyle} // Apply the width and padding
              >
                Enroll
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Videos = () => {
  return (
    <div className="flex-1 p-4">
      {/* Videos content goes here */}
      <div className="text-xl">Videos</div>
      <div className="grid grid-cols-2 gap-4">
        {videosData.map((video) => (
          <div key={video.id} className="bg-gray-200 p-4">
            <h3 className="text-lg font-semibold">{video.title}</h3>
            <video controls className="w-full">
              <source src={video.videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}
      </div>
    </div>
  );
};

const Dashboard = () => {
  const [selectedTab, setSelectedTab] = useState('profile');

  // Mock user profile data (replace this with your actual data)
  const userProfile = {
    name: 'Your Name',
    sgpa: 9.0,
    // Add more user profile details as needed
  };

  return (
    <div className="flex">
      <Sidebar setSelectedTab={setSelectedTab} />
      {selectedTab === 'profile' && <Profile userProfile={userProfile} />}
      {selectedTab === 'courses' && <Courses />}
      {selectedTab === 'videos' && <Videos />}
    </div>
  );
};

export default function Home() {
  return <Dashboard />;
}
